<div class="document-upload-page">

  <!-- =====================================================
       PAGE HEADER
  ====================================================== -->
  <div class="page-header">
    <div>
      <!-- <div class="page-header__eyebrow">
        <i class="pi pi-file-edit"></i>
        Document Workflow
      </div> -->

      <h2>Upload & Create Document</h2>

      <p>
        Complete each step to prepare your learning content.
      </p>
    </div>

    <button type="button" class="btn btn-light" (click)="goBack()">
      <i class="pi pi-arrow-left"></i>
      Back
    </button>
  </div>


  <!-- =====================================================
       STEPPER
  ====================================================== -->
  <div class="workflow-stepper">

    <div class="step" *ngFor="let item of steps; let i = index" [class.active]="currentStep === i"
      [class.completed]="currentStep > i">

      <div class="step__icon">

        <i *ngIf="currentStep > i" class="pi pi-check"></i>

        <i *ngIf="currentStep <= i" [class]="item.icon"></i>

      </div>

      <div class="step__content">
        <!-- <span class="step__number">
          Step {{ i + 1 }}
        </span> -->

        <span class="step__title">
          {{ item.title }}
        </span>

        <span class="step__description">
          {{ item.description }}
        </span>
      </div>

      <div class="step__line" *ngIf="i < steps.length - 1"></div>

    </div>

  </div>


  <!-- =====================================================
       CONTENT CARD
  ====================================================== -->
  <div class="workflow-card">

    <!-- ===================================================
         STEP 1 : UPLOAD DOCUMENT
    ==================================================== -->
    <section *ngIf="currentStep === 0" class="upload-step">

      <!-- Header -->
      <!-- <div class="section-header">
        <div class="section-header__icon document">
          <i class="pi pi-file"></i>
        </div>

        <div class="section-header__content">
          <h3>Upload Document</h3>
          <p>Add document details and configure how it will be used.</p>
        </div>

        <div class="section-header__badge">
          Step 1 of 5
        </div>
      </div> -->

      <!-- Two Column Form -->
      <div class="upload-layout">

        <!-- LEFT -->
        <div class="upload-layout__left">

          <!-- Document Upload -->
          <div class="form-card">

            <div class="form-card__header">
              <div>
                <h4>Document</h4>
                <p>Upload the file you want to add.</p>
              </div>

              <span class="required-badge">Required</span>
            </div>

            <div class="upload-box" [class.has-file]="selectedFile" (click)="fileInput.click()">

              <input #fileInput type="file" hidden accept=".pdf,.doc,.docx,.txt" (change)="onFileSelected($event)" />

              <ng-container *ngIf="!selectedFile">

                <div class="upload-box__icon">
                  <i class="pi pi-cloud-upload"></i>
                </div>

                <h4>Upload your document</h4>

                <p>
                  Drag & drop your file here or
                  <span>browse files</span>
                </p>

                <small>PDF, DOC, DOCX or TXT · Maximum 25 MB</small>

              </ng-container>

              <ng-container *ngIf="selectedFile">

                <div class="upload-box__icon success">
                  <i class="pi pi-file-check"></i>
                </div>

                <h4>{{ selectedFile.name }}</h4>

                <p>{{ formatFileSize(selectedFile.size) }}</p>

                <small>Click to replace the document</small>

              </ng-container>

            </div>

            <!-- Selected File -->
            <div class="selected-file" *ngIf="selectedFile">

              <div class="selected-file__left">

                <div class="file-icon">
                  <i class="pi pi-file"></i>
                </div>

                <div class="file-details">
                  <strong>{{ selectedFile.name }}</strong>
                  <span>{{ formatFileSize(selectedFile.size) }}</span>
                </div>

              </div>

              <button type="button" class="icon-button danger" title="Remove document" (click)="removeFile($event)">
                <i class="pi pi-trash"></i>
              </button>

            </div>

          </div>


          <!-- Document Information -->
          <div class="form-card">

            <div class="form-card__header">
              <div>
                <h4>Document Information</h4>
                <p>Give your document a meaningful name and description.</p>
              </div>
            </div>

            <!-- Title -->
            <div class="form-field">

              <label for="documentTitle">
                Document Title
                <span class="required">*</span>
              </label>

              <div class="input-wrapper">
                <i class="pi pi-file-edit"></i>

                <input id="documentTitle" type="text" [(ngModel)]="documentTitle" maxlength="150"
                  placeholder="Enter document title" />
              </div>

              <div class="field-footer">
                <span>Use a clear and meaningful title.</span>
                <small>{{ documentTitle?.length || 0 }}/150</small>
              </div>

            </div>


            <!-- Description -->
            <div class="form-field">

              <label for="documentDescription">
                Description
              </label>

              <textarea id="documentDescription" [(ngModel)]="description" rows="5" maxlength="500"
                placeholder="Enter a short description about this document..."></textarea>

              <div class="field-footer">
                <span>Help learners understand this document.</span>
                <small>{{ description?.length || 0 }}/500</small>
              </div>

            </div>

          </div>

        </div>


        <!-- RIGHT -->
        <div class="upload-layout__right">

          <!-- Settings -->
          <div class="form-card">

            <div class="form-card__header">
              <div>
                <h4>Document Settings</h4>
                <p>Configure document access and visibility.</p>
              </div>

              <i class="pi pi-cog header-icon"></i>
            </div>


            <!-- Policy -->
            <div class="form-field">

              <label for="policy">
                Policy State
                <span class="required">*</span>
              </label>

              <div class="select-wrapper">

                <i class="pi pi-shield"></i>

                <select id="policy" [(ngModel)]="selectedPolicy">
                  <option value="">Select policy state</option>

                  <!-- <option *ngFor="let policy of policies " [value]="policy.id">
                    {{ policy.name }}
                  </option> -->
                  <option *ngFor="let state of stateNames | keyvalue" [value]="state.key">
                    {{ state.value }}
                  </option>
                </select>

                <i class="pi pi-chevron-down select-arrow"></i>

              </div>

              <span class="field-help">
                Select the applicable document policy.
              </span>

            </div>

            <!--Download-->
            <div class="form-field">

              <label>Document Download</label>

              <div class="status-card">

                <div class="status-card__content">

                  <div class="status-card__icon">
                    <i [class]="isDownload
                    ? 'pi pi-eye'
                    : 'pi pi-eye-slash'"></i>
                  </div>

                  <div>
                    <strong>
                      {{ isDownload ? 'Active' : 'Inactive' }}
                    </strong>

                    <span>
                      {{ isDownload
                      ? 'Visible to users'
                      : 'Hidden from users'
                      }}
                    </span>
                  </div>

                </div>

                <label class="switch">

                  <input type="checkbox" [(ngModel)]="isDownload" />

                  <span class="switch__slider"></span>

                </label>

              </div>

            </div>

          </div>


          <!-- Document Summary -->
          <div class="form-card summary-card">

            <div class="form-card__header">

              <div>
                <h4>Document Summary</h4>
                <p>Review your document information.</p>
              </div>

              <i class="pi pi-check-circle summary-icon"></i>

            </div>

            <div class="summary-list">

              <div class="summary-item">

                <span>
                  <i class="pi pi-file"></i>
                  File
                </span>

                <strong>
                  {{ selectedFile ? selectedFile.name : 'Not selected' }}
                </strong>

              </div>

              <div class="summary-item">

                <span>
                  <i class="pi pi-pencil"></i>
                  Title
                </span>

                <strong>
                  {{ documentTitle || 'Not entered' }}
                </strong>

              </div>

              <div class="summary-item">

                <span>
                  <i class="pi pi-shield"></i>
                  Policy State
                </span>

                <strong>
                  {{ selectedPolicy || 'Not selected' }}
                </strong>

              </div>

              <div class="summary-item">

                <span>
                  <i class="pi pi-eye"></i>
                  Docoument Download
                </span>

                <strong [class.active]="isActive" [class.inactive]="!isActive">
                  {{ isDownload ? 'Active' : 'Inactive' }}
                </strong>

              </div>

            </div>

          </div>


          <!-- Next Step Information -->
          <!-- <div class="next-step-card">

            <div class="next-step-card__icon">
              <i class="pi pi-list-check"></i>
            </div>

            <div>
              <span>Next Step</span>
              <strong>Assessment</strong>
              <p>
                After saving, you can create questions
                for this document.
              </p>
            </div>

          </div> -->

        </div>

      </div>


      <!-- Footer -->
      <div class="action-footer">

        <div class="action-footer__hint">

          <div class="action-footer__hint-icon">
            <i class="pi pi-info-circle"></i>
          </div>

          <div>
            <strong>Ready to continue?</strong>

            <span>
              You can edit the document before saving.
            </span>
          </div>

        </div>

        <button type="button" class="btn btn-primary continue-button" [disabled]="
        !selectedFile ||
        !documentTitle?.trim() ||
        !selectedPolicy ||
        isUploading
      " (click)="continueToEditor()">
          <span>Continue to Editor</span>
          <i class="pi pi-arrow-right"></i>
        </button>

      </div>

    </section>


    <!-- ===================================================
     STEP 2 : ASSESSMENT
==================================================== -->
    <section *ngIf="currentStep === 1" class="assessment-step">

      <!-- =====================================================
       ASSESSMENT HEADER
  ====================================================== -->
      <div class="assessment-page-header">

        <div class="assessment-heading">

          <div class="assessment-heading-icon">
            <i class="pi pi-list-check"></i>
          </div>

          <div>
            <h2>Create Assessment</h2>

            <p>
              Create questions to evaluate learner understanding.
            </p>
          </div>

        </div>

        <div class="assessment-count">
          <i class="pi pi-question-circle"></i>
          {{ questions.length }} Questions
        </div>

      </div>


      <!-- =====================================================
       ASSESSMENT TYPE
  ====================================================== -->
      <div class="assessment-panel">

        <div class="panel-heading">

          <div>
            <h3>Assessment Type</h3>

            <p>
              Choose how you want to create your assessment.
            </p>
          </div>

        </div>


        <div class="assessment-mode-grid">

          <!-- MANUAL -->
          <button type="button" class="mode-card" [class.active]="assessmentMode === 'manual'"
            (click)="assessmentMode = 'manual'">

            <div class="mode-card-icon manual">
              <i class="pi pi-pencil"></i>
            </div>

            <div class="mode-card-content">

              <div class="mode-card-title">
                <strong>Manual Assessment</strong>

                <span class="mode-radio" [class.checked]="assessmentMode === 'manual'">
                  <i *ngIf="assessmentMode === 'manual'" class="pi pi-check"></i>
                </span>
              </div>

              <p>
                Create questions, choices and correct answers manually.
              </p>

            </div>

          </button>


          <!-- AI -->
          <!-- <button type="button" class="mode-card" [class.active]="assessmentMode === 'ai'"
            (click)="assessmentMode = 'ai'">

            <div class="mode-card-icon ai">
              <i class="pi pi-sparkles"></i>
            </div>

            <div class="mode-card-content">

              <div class="mode-card-title">

                <strong>AI Generate Assessment</strong>

                <span class="mode-radio" [class.checked]="assessmentMode === 'ai'">
                  <i *ngIf="assessmentMode === 'ai'" class="pi pi-check"></i>
                </span>

              </div>

              <p>
                Generate questions automatically from the uploaded document.
              </p>

            </div>

          </button> -->

        </div>

      </div>


      <!-- =====================================================
       SETTINGS
  ====================================================== -->
      <div class="assessment-panel">

        <div class="panel-heading">

          <div>
            <h3>Assessment Settings</h3>

            <p>
              Configure marks, passing criteria and retake options.
            </p>
          </div>

        </div>


        <div class="assessment-settings-grid">

          <!-- RETEST -->
          <div class="setting-box">

            <div class="setting-box-icon">
              <i class="pi pi-refresh"></i>
            </div>

            <div class="setting-box-content">

              <strong>Allow Re-test</strong>

              <span>
                Learners can retake this assessment.
              </span>

            </div>

            <label class="custom-switch">

              <input type="checkbox" [(ngModel)]="assessmentSettings.allowRetest" />

              <span class="switch-slider"></span>

            </label>

          </div>


          <!-- MAXIMUM MARKS -->
          <div class="setting-box input-box">

            <div class="setting-box-icon">
              <i class="pi pi-star"></i>
            </div>

            <div class="setting-box-content">

              <label>
                Maximum Marks
              </label>

              <input type="number" min="1" [(ngModel)]="assessmentSettings.maximumMarks" placeholder="100" />

            </div>

          </div>


          <!-- PASS PERCENTAGE -->
          <div class="setting-box input-box">

            <div class="setting-box-icon">
              <i class="pi pi-percentage"></i>
            </div>

            <div class="setting-box-content">

              <label>
                Pass Percentage
              </label>

              <input type="number" min="1" max="100" [(ngModel)]="assessmentSettings.passPercentage" placeholder="60" />

            </div>

          </div>

        </div>

      </div>


      <!-- =====================================================
       QUESTIONS
  ====================================================== -->
      <div class="questions-panel">

        <!-- Questions Header -->
        <div class="questions-panel-header">

          <div class="questions-heading">

            <div class="questions-heading-icon">
              <i class="pi pi-list-check"></i>
            </div>

            <div>
              <h3>Questions</h3>

              <p>
                Add questions and mark the correct answer.
              </p>
            </div>

          </div>


          <div class="total-marks">

            <span>Total Marks</span>

            <strong>
              {{ getTotalQuestionMarks() }}
            </strong>

          </div>

        </div>


        <!-- =================================================
         QUESTION
    ================================================== -->
        <div class="questions-container">

          <div class="question-editor" *ngFor="
          let question of questions;
          let questionIndex = index
        ">

            <!-- QUESTION TOP -->
            <div class="question-editor-header">

              <div class="question-title">

                <span class="question-number">
                  {{ questionIndex + 1 }}
                </span>

                <div>
                  <strong>
                    Question {{ questionIndex + 1 }}
                  </strong>

                  <span>
                    Add question and answer choices
                  </span>
                </div>

              </div>


              <div class="question-header-actions">

                <span class="question-mark-badge">
                  {{ question.marks || 0 }}
                  {{ question.marks == 1 ? 'Mark' : 'Marks' }}
                </span>

                <button type="button" class="question-delete" *ngIf="questions.length > 1"
                  (click)="removeQuestion(questionIndex)" title="Delete question">
                  <i class="pi pi-trash"></i>
                </button>

              </div>

            </div>


            <!-- QUESTION BODY -->
            <div class="question-editor-body">

              <!-- QUESTION TEXT -->
              <div class="form-group">

                <label>
                  Question
                  <span>*</span>
                </label>

                <textarea [(ngModel)]="question.question" class="question-input" rows="3"
                  placeholder="Type your question here..."></textarea>

              </div>


              <!-- QUESTION SETTINGS -->
              <div class="question-settings">

                <div class="form-group">

                  <label>
                    Question Type
                  </label>

                  <div class="select-field">

                    <select [(ngModel)]="question.type">
                      <option value="single">
                        Single Choice
                      </option>

                      <option value="multiple">
                        Multiple Choice
                      </option>
                    </select>

                    <i class="pi pi-chevron-down"></i>

                  </div>

                </div>


                <div class="form-group marks-field">

                  <label>
                    Marks
                    <span>*</span>
                  </label>

                  <div class="marks-input">

                    <i class="pi pi-star"></i>

                    <input type="number" min="1" [(ngModel)]="question.marks" />

                  </div>

                </div>

              </div>


              <!-- ANSWERS -->
              <div class="answers-section">

                <div class="answers-header">

                  <div>

                    <label>
                      Answer Choices
                      <span>*</span>
                    </label>

                    <small>
                      Select the correct answer.
                    </small>

                  </div>

                  <span>
                    {{ question.options.length }} Choices
                  </span>

                </div>


                <!-- OPTIONS -->
                <div class="answer-list">

                  <div class="answer-item" *ngFor="
                  let option of question.options;
                  let optionIndex = index
                " [class.correct]="option.isCorrect">

                    <!-- SINGLE -->
                    <button *ngIf="question.type === 'single'" type="button" class="answer-selector radio"
                      [class.selected]="option.isCorrect" (click)="selectCorrectAnswer(question, optionIndex)">
                      <span>
                        <i *ngIf="option.isCorrect" class="pi pi-check"></i>
                      </span>
                    </button>


                    <!-- MULTIPLE -->
                    <button *ngIf="question.type === 'multiple'" type="button" class="answer-selector checkbox"
                      [class.selected]="option.isCorrect" (click)="selectCorrectAnswer(question, optionIndex)">
                      <span>
                        <i *ngIf="option.isCorrect" class="pi pi-check"></i>
                      </span>
                    </button>


                    <!-- LETTER -->
                    <div class="answer-letter">
                      {{ getOptionLetter(optionIndex) }}
                    </div>


                    <!-- INPUT -->
                    <input type="text" [(ngModel)]="option.text" class="answer-input" [placeholder]="
                    'Enter option ' +
                    getOptionLetter(optionIndex)
                  " />


                    <!-- CORRECT -->
                    <span class="correct-label" *ngIf="option.isCorrect">
                      <i class="pi pi-check-circle"></i>
                      Correct
                    </span>


                    <!-- DELETE -->
                    <button type="button" class="answer-delete" *ngIf="question.options.length > 2"
                      (click)="removeOption(question, optionIndex)">
                      <i class="pi pi-times"></i>
                    </button>

                  </div>

                </div>


                <!-- ADD CHOICE -->
                <button type="button" class="add-choice" (click)="addOption(question)">

                  <i class="pi pi-plus"></i>

                  Add Choice

                </button>

              </div>

            </div>

          </div>


          <!-- =================================================
           ADD QUESTION
      ================================================== -->
          <button type="button" class="add-question" (click)="addQuestion()">

            <span class="add-question-icon">
              <i class="pi pi-plus"></i>
            </span>

            <span class="add-question-content">

              <strong>
                Add More Question
              </strong>

              <small>
                Create another question for this assessment
              </small>

            </span>

            <i class="pi pi-arrow-right add-question-arrow"></i>

          </button>

        </div>

      </div>


      <!-- =====================================================
       FOOTER
  ====================================================== -->
      <div class="assessment-actions">

        <div class="assessment-help">

          <i class="pi pi-info-circle"></i>

          <span>
            Make sure each question has a correct answer.
          </span>

        </div>


        <div class="assessment-buttons">

          <button type="button" class="btn-secondary" (click)="saveAssessment()">
            <i class="pi pi-save"></i>
            Save Assessment
          </button>


          <button type="button" class="btn-primary" (click)="continueToSurvey()">
            Continue to Survey
            <i class="pi pi-arrow-right"></i>
          </button>

        </div>

      </div>

    </section>


    <!-- ===================================================
     STEP 3 : SURVEY
==================================================== -->
    <section *ngIf="currentStep === 2" class="survey-step">

      <!-- Header -->
      <div class="section-header">
        <div class="section-header__icon survey">
          <i class="pi pi-comments"></i>
        </div>

        <div class="section-header__content">
          <h3>Create Survey</h3>
          <p>Collect feedback and opinions from your learners.</p>
        </div>
      </div>


      <!-- =================================================
       SURVEY EMPTY STATE
  ================================================== -->
      <div class="survey-empty" *ngIf="!surveyStarted">

        <div class="survey-empty__icon">
          <i class="pi pi-comments"></i>
        </div>

        <h3>Create your first survey</h3>

        <p>
          Add questions and choices to collect meaningful feedback
          from your learners.
        </p>

        <button type="button" class="btn btn-primary survey-empty__button" (click)="startSurvey()">

          <i class="pi pi-plus"></i>

          Add New Survey
        </button>

      </div>


      <!-- =================================================
       SURVEY BUILDER
  ================================================== -->
      <div class="survey-builder" *ngIf="surveyStarted">

        <!-- Builder Top Bar -->
        <div class="survey-builder__top">

          <div>
            <h4>Survey Questions</h4>

            <p>
              Create questions and add answer choices for your learners.
            </p>
          </div>

          <div class="survey-count">
            <i class="pi pi-list"></i>

            {{ surveyQuestions.length }}
            {{ surveyQuestions.length === 1 ? 'Question' : 'Questions' }}
          </div>

        </div>


        <!-- =================================================
         QUESTIONS
    ================================================== -->
        <div class="survey-questions">

          <div class="question-card" *ngFor="let question of surveyQuestions; let questionIndex = index">

            <!-- Question Header -->
            <div class="question-card__header">

              <div class="question-number">
                {{ questionIndex + 1 }}
              </div>

              <div class="question-title">
                <span>
                  Question {{ questionIndex + 1 }}
                </span>

                <small>
                  {{ question.choices.length }}
                  {{ question.choices.length === 1 ? 'choice' : 'choices' }}
                </small>
              </div>

              <button type="button" class="question-delete" *ngIf="surveyQuestions.length > 1"
                (click)="removeSurveyQuestion(questionIndex)" title="Remove question">

                <i class="pi pi-trash"></i>
              </button>

            </div>


            <!-- Question Input -->
            <div class="question-card__body">

              <div class="form-group">

                <label>
                  Question
                  <span class="required">*</span>
                </label>

                <input type="text" class="form-control" [(ngModel)]="question.question"
                  placeholder="Enter your survey question..." />

              </div>


              <!-- Choices -->
              <div class="choices-section">

                <div class="choices-header">

                  <div>
                    <label>
                      Answer Choices
                      <span class="required">*</span>
                    </label>

                    <small>
                      Add the options learners can choose from.
                    </small>
                  </div>

                </div>


                <!-- Choice List -->
                <div class="choices-list">

                  <div class="choice-row" *ngFor="let choice of question.choices; let choiceIndex = index">

                    <div class="choice-index">
                      {{ choiceIndex + 1 }}
                    </div>

                    <div class="choice-input">

                      <input type="text" class="form-control" [(ngModel)]="question.choices[choiceIndex]"
                        placeholder="Enter choice..." />

                    </div>

                    <button type="button" class="choice-remove" *ngIf="question.choices.length > 1"
                      (click)="removeSurveyChoice(questionIndex, choiceIndex)" title="Remove choice">

                      <i class="pi pi-times"></i>

                    </button>

                  </div>

                </div>


                <!-- Add Choice -->
                <button type="button" class="add-choice-btn" (click)="addSurveyChoice(questionIndex)">

                  <i class="pi pi-plus"></i>

                  Add More Choice

                </button>

              </div>

            </div>

          </div>

        </div>


        <!-- Add Question -->
        <button type="button" class="add-question-btn" (click)="addSurveyQuestion()">

          <span class="add-question-btn__icon">
            <i class="pi pi-plus"></i>
          </span>

          <span>
            <strong>Add More Question</strong>
            <small>Create another survey question</small>
          </span>

          <i class="pi pi-arrow-right"></i>

        </button>


        <!-- =================================================
         FOOTER
    ================================================== -->
        <div class="survey-footer">

          <button type="button" class="btn btn-outline-secondary" (click)="previousStep()">

            <i class="pi pi-arrow-left"></i>

            Back
          </button>


          <div class="survey-footer__right">

            <button type="button" class="btn btn-outline-primary" (click)="saveSurvey()">

              <i class="pi pi-save"></i>

              Save Survey

            </button>


            <button type="button" class="btn btn-primary" (click)="continueToPoll()">

              Continue to Poll

              <i class="pi pi-arrow-right"></i>

            </button>

          </div>

        </div>

      </div>

    </section>


    <!-- ===================================================
     STEP 4 : POLL
==================================================== -->
    <section *ngIf="currentStep === 3" class="poll-step">

      <!-- Section Header -->
      <div class="section-header">
        <div class="section-header__icon poll">
          <i class="pi pi-chart-bar"></i>
        </div>

        <div class="section-header__content">
          <h3>Create Poll</h3>
          <p>
            Create quick polls to collect learner responses and
            encourage engagement.
          </p>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-step" *ngIf="!showPollBuilder">

        <div class="empty-step__icon">
          <i class="pi pi-chart-bar"></i>
        </div>

        <h3>Create a Poll</h3>

        <p>
          Add a question and choices to create an interactive poll
          for your learners.
        </p>

        <button type="button" class="btn btn-primary" (click)="addNewPoll()">
          <i class="pi pi-plus"></i>
          Add New Poll
        </button>

      </div>


      <!-- Poll Builder -->
      <div class="poll-builder" *ngIf="showPollBuilder">

        <!-- Builder Header -->
        <div class="poll-builder__top">

          <div>
            <h3>Poll Questions</h3>
            <p>
              Add questions and provide choices for learners.
            </p>
          </div>

          <button type="button" class="btn btn-outline-primary" (click)="addPollQuestion()">
            <i class="pi pi-plus"></i>
            Add More Question
          </button>

        </div>


        <!-- Questions -->
        <div class="poll-question-card" *ngFor="let question of pollQuestions; let questionIndex = index">

          <!-- Question Header -->
          <div class="poll-question-card__header">

            <div class="question-number">
              {{ questionIndex + 1 }}
            </div>

            <div class="question-title">
              <h4>Question {{ questionIndex + 1 }}</h4>
              <span>
                Add a question and at least two choices.
              </span>
            </div>

            <button *ngIf="pollQuestions.length > 1" type="button" class="icon-button danger" title="Remove question"
              (click)="removePollQuestion(questionIndex)">
              <i class="pi pi-trash"></i>
            </button>

          </div>


          <!-- Question Input -->
          <div class="poll-form-group">

            <label>
              Question
              <span class="required">*</span>
            </label>

            <textarea class="poll-input poll-question-input" rows="3" placeholder="Enter your poll question..."
              [(ngModel)]="question.question" [name]="'pollQuestion' + questionIndex"></textarea>

            <div class="input-hint">
              Ask a clear question that learners can answer easily.
            </div>

          </div>


          <!-- Choices -->
          <div class="choices-section">

            <div class="choices-section__header">

              <div>
                <label>
                  Choices
                  <span class="required">*</span>
                </label>

                <span class="choice-count">
                  {{ question.choices.length }} choices
                </span>
              </div>

              <button type="button" class="add-choice-button" (click)="addPollChoice(questionIndex)">
                <i class="pi pi-plus"></i>
                Add More Choice
              </button>

            </div>


            <!-- Choice List -->
            <div class="choice-list">

              <div class="choice-row" *ngFor="
              let choice of question.choices;
              let choiceIndex = index
            ">

                <div class="choice-indicator">
                  {{ getChoiceLetter(choiceIndex) }}
                </div>

                <input type="text" class="poll-input choice-input" placeholder="Enter choice..."
                  [(ngModel)]="question.choices[choiceIndex]" [name]="
                'pollChoice' +
                questionIndex +
                '_' +
                choiceIndex
              " />

                <button type="button" class="icon-button danger" title="Remove choice"
                  [disabled]="question.choices.length <= 2" (click)="removePollChoice(questionIndex, choiceIndex)">
                  <i class="pi pi-trash"></i>
                </button>

              </div>

            </div>


            <div class="choices-info">
              <i class="pi pi-info-circle"></i>
              Add at least two choices for each question.
            </div>

          </div>

        </div>


        <!-- Add Question Bottom -->
        <button type="button" class="add-question-card" (click)="addPollQuestion()">
          <span class="add-question-card__icon">
            <i class="pi pi-plus"></i>
          </span>

          <span>
            <strong>Add More Question</strong>
            <small>Add another poll question</small>
          </span>

          <i class="pi pi-chevron-right"></i>
        </button>

      </div>


      <!-- Footer -->
      <div class="step-footer" *ngIf="showPollBuilder">

        <button type="button" class="btn btn-light" (click)="previousStep()">
          <i class="pi pi-arrow-left"></i>
          Back
        </button>

        <div class="step-footer__right">

          <button type="button" class="btn btn-outline-primary" (click)="savePoll()">
            <i class="pi pi-save"></i>
            Save Poll
          </button>

          <button type="button" class="btn btn-primary" (click)="continueToNote()">
            Continue to Note
            <i class="pi pi-arrow-right"></i>
          </button>

        </div>

      </div>

    </section>


    <!-- ===================================================
         STEP 5 : NOTE
    ==================================================== -->
    <section *ngIf="currentStep === 4">

      <div class="section-header">
        <div class="section-header__icon note">
          <i class="pi pi-bookmark"></i>
        </div>

        <div>
          <h3>Add Notes</h3>
          <p>
            Add additional notes for this learning content.
          </p>
        </div>
      </div>

      <div class="note-editor">

        <label>
          Notes
        </label>

        <textarea [(ngModel)]="noteText" placeholder="Write your notes here..."></textarea>

      </div>

      <div class="action-footer">

        <button type="button" class="btn btn-light" (click)="previousStep()">
          <i class="pi pi-arrow-left"></i>
          Previous
        </button>

        <button type="button" class="btn btn-success" (click)="saveWorkflow()">
          <i class="pi pi-check"></i>
          Complete Workflow
        </button>

      </div>

    </section>

  </div>

</div>


<!-- =======================================================
     DOCUMENT EDITOR MODAL
======================================================== -->
<div class="modal-backdrop" *ngIf="showEditor">

  <div class="document-editor">

    <div class="document-editor__header">

      <div>
        <span class="editor-label">
          Document Editor
        </span>

        <h3>
          Edit Document
        </h3>
      </div>

      <button type="button" class="icon-button" (click)="closeEditor()">
        <i class="pi pi-times"></i>
      </button>

    </div>


    <div class="document-editor__body">
      <app-excel-editor [file]="upLoadedFileList[0] ?? null" [documentId]="documentId"
        [documentFileName]="documentFileName" [documentFileType]="documentFileType" [companyId]="companyIdForConversion"
        [classId]="selectedFolderId" [modelType]="activeFolderModelType" [documentTitle]="documentTitle"
        [stateCode]="selectedPolicy" [chatUserList]="selectedClassList" [isDownload]="isDownload"
        [docTrainId]="docTrainId" [messageId]="message_id" [(visible)]="showExcelEditor"
        (onSave)="onExcelEditorSave($event)" (onCancel)="onExcelEditorCancel()">
      </app-excel-editor>

    </div>


    <div class="document-editor__footer">

      <button type="button" class="btn btn-light" (click)="closeEditor()">
        Cancel
      </button>

      <button type="button" class="btn btn-primary" (click)="saveDocument()">
        <i class="pi pi-save"></i>
        Save & Complete
      </button>

    </div>

  </div>

</div>


<!-- =======================================================
     CONTINUE CONFIRMATION DIALOG
======================================================== -->
<div class="modal-backdrop" *ngIf="showContinueDialog">

  <div class="confirm-dialog">

    <div class="confirm-dialog__icon">
      <i class="pi pi-check"></i>
    </div>

    <h3>
      Document Saved
    </h3>

    <p>
      Your document has been saved successfully.
      Would you like to continue to the next step?
    </p>

    <div class="confirm-dialog__actions">

      <button type="button" class="btn btn-light" (click)="saveOnly()">
        <i class="pi pi-save"></i>
        No, Save Only
      </button>

      <button type="button" class="btn btn-primary" (click)="continueNextStep()">
        Yes, Continue
        <i class="pi pi-arrow-right"></i>
      </button>

    </div>

  </div>

</div>
